export let SIDE_NAV_OPTIONS = []
export let BOTTOM_NAV_OPTIONS = []
export let MQTT_OPTIONS = {}
export let MQTT_BASE_TOPIC = ''

export function setXappCoreConstants(constants = {}) {
  SIDE_NAV_OPTIONS = constants.SIDE_NAV_OPTIONS || []
  BOTTOM_NAV_OPTIONS = constants.BOTTOM_NAV_OPTIONS || []
  MQTT_OPTIONS = constants.MQTT_OPTIONS || {}
  MQTT_BASE_TOPIC = constants.MQTT_BASE_TOPIC || ''
}
